import { Routes } from '@angular/router';
import { ExternalLinkRedirectComponent } from './components/external-link-redirect/external-link-redirect.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { ControlPanelComponent } from './pages/control-panel/control-panel.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ExperiencesComponent } from './pages/experiences/experiences.component';
import { ExperienceComponent } from './modules/experience/experience.component';
import { CheckoutComponent } from './pages/checkout/checkout/checkout.component';
import { TerritoriesComponent } from './pages/territories/territories/territories.component';
import { RegionsComponent } from './pages/regions/regions/regions.component';
import { ConfirmationComponent } from './pages/checkout/confirmation/confirmation.component';

// Routes comuni (senza homepage nel path)
const appRoutes: Routes = [
  /* WordPress pretty link /link/<id> — non è route app; reindirizza al sito pubblico */
  { path: 'link/:id', component: ExternalLinkRedirectComponent },
  { path: 'territories/:label', component: TerritoriesComponent },
  { path: 'regions/:label', component: RegionsComponent },
  { path: 'control-panel', component: ControlPanelComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'experiences', component: ExperiencesComponent },
  { path: 'winery', component: ExperiencesComponent },
  { path: 'region', component: ExperiencesComponent },
  { path: 'wine_region', component: ExperiencesComponent },
  { path: 'experience/:experience_name__experience_id', component: ExperienceComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'territories', component: TerritoriesComponent },
  { path: 'confirmation', component: ConfirmationComponent }
];

// Routes principali con supporto multilingua
export const routes: Routes = [
  // Italiano: / e /homepage → HomepageComponent (backward compat)
  // pathMatch: 'full' obbligatorio: senza, path: '' usa prefix e può “mangiare” /en, /de, /fr.
  { path: '', component: HomepageComponent, pathMatch: 'full' },
  { path: 'homepage', redirectTo: '', pathMatch: 'full' },
  ...appRoutes,

  // Inglese: /en/ → HomepageComponent
  {
    path: 'en',
    children: [
      { path: '', component: HomepageComponent, pathMatch: 'full' },
      { path: 'homepage', redirectTo: '', pathMatch: 'full' },
      ...appRoutes
    ]
  },
  // Tedesco: /de/
  {
    path: 'de',
    children: [
      { path: '', component: HomepageComponent, pathMatch: 'full' },
      { path: 'homepage', redirectTo: '', pathMatch: 'full' },
      ...appRoutes
    ]
  },
  // Francese: /fr/
  {
    path: 'fr',
    children: [
      { path: '', component: HomepageComponent, pathMatch: 'full' },
      { path: 'homepage', redirectTo: '', pathMatch: 'full' },
      ...appRoutes
    ]
  }
];
